import { useState } from "react"
import { Copy, Check } from "lucide-react"

interface CopyButtonProps {
  text: string
  size?: "sm" | "md"
  title?: string
}

export const CopyButton = ({ text, size = "sm", title = "Copier" }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)
  const iconClass = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"

  const handleCopy = () => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <button onClick={handleCopy} className="text-gray-300 hover:text-primary transition-colors shrink-0" title={title}>
      {copied ? <Check className={`${iconClass} text-success`} /> : <Copy className={iconClass} />}
    </button>
  )
}
